export default class WorkingHours {
    public mondayFrom?: Date
    public mondayTo?: Date
    public tuesdayFrom?: Date
    public tuesdayTo?: Date
    public wednesdayFrom?: Date
    public wednesdayTo?: Date
    public thursdayFrom?: Date
    public thursdayTo?: Date
    public fridayFrom?: Date
    public fridayTo?: Date
    public saturdayFrom?: Date
    public saturdayTo?: Date
    public sundayFrom?: Date
    public sundayTo?: Date

    constructor({
                    mondayFrom, mondayTo, tuesdayFrom, tuesdayTo, wednesdayFrom, wednesdayTo,
                    thursdayFrom, thursdayTo, fridayFrom, fridayTo, saturdayFrom, saturdayTo,
                    sundayFrom, sundayTo
                }: any) {
        var d = new Date();
        d.setHours(0,0,0);
        this.mondayFrom = mondayFrom || d;
        this.mondayTo = mondayTo || d;
        this.tuesdayFrom = tuesdayFrom || d;
        this.tuesdayTo = tuesdayTo || d;
        this.wednesdayFrom = wednesdayFrom || d;
        this.wednesdayTo = wednesdayTo || d;
        this.thursdayFrom = thursdayFrom || d;
        this.thursdayTo = thursdayTo || d;
        this.fridayFrom = fridayFrom || d;
        this.fridayTo = fridayTo || d;
        this.saturdayFrom = saturdayFrom || d;
        this.saturdayTo = saturdayTo || d;
        this.sundayFrom = sundayFrom || d;
        this.sundayTo = sundayTo || d;
    }
}
